import React, { useEffect } from 'react';

const loadScript = (src) =>
  new Promise((resolve, reject) => {
    const existing = document.querySelector(`script[src="${src}"]`);
    if (existing) {
      if (existing.dataset.loaded === 'true') {
        resolve();
        return;
      }
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), {
        once: true,
      });
      return;
    }

    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.dataset.loaded = 'false';
    script.onload = () => {
      script.dataset.loaded = 'true';
      resolve();
    };
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.body.appendChild(script);
  });

const CanvasBackground = () => {
  useEffect(() => {
    let cancelled = false;

    const init = async () => {
      try {
        await loadScript('/js/util.tsx');
        await loadScript('/js/pipeline.tsx');
        if (cancelled) return;
        window.setupPipeline?.();
      } catch {
        // background opcional
      }
    };

    init();

    return () => {
      cancelled = true;
      window.teardownPipeline?.();
    };
  }, []);

  return (
    <div
      className="content content--canvas pointer-events-none fixed inset-0 -z-10"
      aria-hidden="true"
    />
  );
};

export default CanvasBackground;
